import React from "react";
import { goToCheckout } from "@/lib/checkout";

const GOOGLE_AUTH_URL = process.env.REACT_APP_GOOGLE_AUTH_URL;

export function startGoogleLogin(redirectPath = "/b2b/registry") {
  const redirectUrl = `${window.location.origin}${redirectPath}`;
  goToCheckout(`${GOOGLE_AUTH_URL}?redirect=${encodeURIComponent(redirectUrl)}`);
}

export default function GoogleAuthButton({ redirectPath = "/b2b/registry", label = "Continuer avec Google" }) {
  return (
    <button
      type="button"
      data-testid="google-auth-button"
      onClick={() => startGoogleLogin(redirectPath)}
      className="w-full flex items-center justify-center gap-3 rounded-xl border border-border bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition-colors"
    >
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden>
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.4 29.3 35 24 35c-6.1 0-11-4.9-11-11s4.9-11 11-11c2.8 0 5.4 1.1 7.3 2.8l5.7-5.7C33.6 6.9 29.1 5 24 5 13.5 5 5 13.5 5 24s8.5 19 19 19 19-8.5 19-19c0-1.2-.1-2.3-.4-3.5z" />
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c2.8 0 5.4 1.1 7.3 2.8l5.7-5.7C33.6 6.9 29.1 5 24 5 16.3 5 9.7 9.3 6.3 14.7z" />
        <path fill="#4CAF50" d="M24 43c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.3 34 26.8 35 24 35c-5.3 0-9.7-2.6-11.3-6.9l-6.5 5C9.5 38.6 16.2 43 24 43z" />
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4.1 5.6l6.2 5.2C41.6 34.9 44 30 44 24c0-1.2-.1-2.3-.4-3.5z" />
      </svg>
      {label}
    </button>
  );
}
